import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles } from "lucide-react";

// C2 (his rule, 30 Oct): a serial on this part that matches a truck's engine serial, build sheet or dataplate is
// SUGGESTED, grey, until a person taps it — and even then they still say how they know. Which of the truck's
// components it IS is optional; picking one links the two, so the truck's row reads PULLED → this part, counted once.
export function SourceTruckComponentPick({ partId, component, onComponent, onMatch, testid = "source-truck" }) {
  const [matches, setMatches] = useState(null);
  const [more, setMore] = useState(0);
  const [groups, setGroups] = useState([]);
  useEffect(() => {
    api.get(`/parts/${partId}/source-truck/serial-matches`).then(({ data }) => {
      setMatches(data.matches || []);
      setMore(data.has_more ? data.total - 20 : 0);
    }).catch(() => setMatches([]));
    api.get("/component-groups").then(({ data }) => setGroups(data.items || [])).catch(() => setGroups([]));
  }, [partId]);
  const chip = (on) => `rounded-lg border-2 px-2.5 h-9 text-xs font-semibold ${on ? "border-[#E0781A] bg-orange-50 text-[#C76714]" : "border-slate-200 bg-white text-slate-600 hover:border-slate-400"}`;
  return (
    <div className="space-y-2">
      {matches?.length > 0 && (
        <div data-testid={`${testid}-serial-matches`} className="rounded-lg border border-dashed border-slate-300 bg-slate-50 p-2.5 space-y-1.5">
          <p className="text-xs text-slate-500 flex items-center gap-1.5">
            <Sparkles className="w-3.5 h-3.5 text-[#C76714]" />A serial on this part matches — suggested, nothing is recorded until you finish below.
          </p>
          {matches.map((m, i) => (
            <button key={`${m.donor_id}-${m.component}`} type="button" data-testid={`${testid}-serial-match-${i}`}
              onClick={() => onMatch(m)}
              className="w-full text-left rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-600 hover:border-[#E0781A]">
              <b className="font-mono">{m.stock_number}</b> · {m.component_label} — {m.matched_in}
              {m.taken_by && <span className="block text-[11px] text-amber-700">its {m.component_label.toLowerCase()} is already {m.taken_by}</span>}
            </button>
          ))}
          {more > 0 && <p data-testid={`${testid}-serial-more`} className="text-[11px] text-amber-700">{more} more truck{more === 1 ? "" : "s"} share this serial — type the stock number below.</p>}
        </div>
      )}
      <div>
        <p className="text-xs font-bold text-slate-600 mb-1.5">Which part of the truck is it? <span className="font-normal text-slate-400">(optional)</span></p>
        <div className="flex flex-wrap gap-1.5">
          <button type="button" data-testid={`${testid}-component-none`} onClick={() => onComponent("")} className={chip(!component)}>Don't say</button>
          {groups.map((g) => (
            <button key={g.code} type="button" data-testid={`${testid}-component-${g.code}`} onClick={() => onComponent(g.code)} className={chip(component === g.code)}>
              {g.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
